




















































import { defineComponent, computed } from '@vue/composition-api';
import { FCPackageType, IPackage } from '~/types/fightcamp';
import FCImage from '~/components/FCImage.vue';
import { useCartContext } from '~/composables/useCartContext';

export const PackageTypeMap: Map<FCPackageType, IPackage> = new Map([
  ['FightCamp Trackers + Bag', { title: 'Trackers + Bag', src: { filename: 'https://a.storyblok.com/f/152150/1053x933/1ce035d2d0/fc-fightcamp-base-with-bag-002.png', alt: 'FightCamp Trackers and Bag Package' } }],
  ['FightCamp Trackers', { title: 'Trackers', src: { filename: 'https://a.storyblok.com/f/152150/1053x789/158eefb115/fc-fightcamp-base-002.png', alt: 'FightCamp Trackers Package' } }],
]);

export default defineComponent({
  name: 'PackagePreview',
  components: {
    FCImage,
  },
  setup() {
    // @ts-ignore
    const { $store } = useNuxtApp();
    const { packageInCartName } = useCartContext();
    const regex = /,.*$/;

    const packageInCart = computed(() => {
      if ($store.getters.isShopifyOn) {
        const pkg = $store.getters.cartProducts.packageInCart;
        return {
          title: pkg?.product.title,
          src: {
            filename: pkg?.product.image,
            alt: pkg?.product.title,
          },
        };
      }
      return PackageTypeMap.get(packageInCartName.value.replace(regex, '') as FCPackageType);
    });

    function openCart() { $store.dispatch('toggleDrawer'); }

    return {
      packageInCart,
      openCart,
      provider: computed(() => ($store.getters.isShopifyOn ? 'fcProvider' : 'storyblok')),
    };
  },
});
